import { render, staticRenderFns } from "./Likes.vue?vue&type=template&id=4e19ff93&"
import script from "./Likes.vue?vue&type=script&lang=js&"
export * from "./Likes.vue?vue&type=script&lang=js&"
import style0 from "./Likes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Likes.vue"
export default component.exports